function isInputField(field) {
  return Boolean(field.target);
}
function isNestedFormField(field) {
  const nestedFormField = field;
  return Boolean(
    nestedFormField.target && nestedFormField.properties.nestedFormId
  );
}
export {
  isInputField,
  isNestedFormField
};
//# sourceMappingURL=form-view.js.map
